import { loginRoutes } from "@login/data/loginRoutes";
import { SSOLogin } from "@login/scenes/SSOLoginPage/SSOLogin";
import type { RouteProps } from "@shared/react-router-dom/react-router-dom";
import { Navigate } from "@shared/react-router-dom/react-router-dom";
import type { Flipper } from "@shared/types/flipper";
import { wildcardPath } from "@shared/utils/wildcardPath/wildcardPath";

interface Route extends Omit<RouteProps, "children" | "component" | "render"> {
  key: string;
  flipper?: Flipper;
}

const baseRoutes: Route[] = [
  {
    path: wildcardPath(loginRoutes.sso_login),
    key: "SSOLogin",
    element: <SSOLogin />,
  },
];

const defaultRoute: Route = {
  key: "Default Redirect",
  element: <Navigate to="/sso_login" replace />,
  path: "*",
};

const routeActive = (route: Route, flippers: Flipper[]) => {
  return !route.flipper || flippers.includes(route.flipper);
};

const activeRoutes = (allRoutes: Route[], flippers: Flipper[]) => {
  return allRoutes
    .filter(route => routeActive(route, flippers))
    .map(({ flipper: unusedFlipper, ...route }) => route);
};

const routes = (flippers: Flipper[]): Route[] => {
  const allRoutes = [...baseRoutes, defaultRoute];

  return activeRoutes(allRoutes, flippers);
};

export type { Route };
export { routes, routeActive, activeRoutes };
